module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargadorDerecha-7023983a.png";